import { Metadata, MetadataInfo } from '@/types/metadata/metadata';
import { emptyMetadata, emptyMetadataInfo } from '@/util/metadata';
import { createContext } from 'react';

type MetadataContextType = {
  metadata: Metadata;
  metadataInfo: MetadataInfo;
};

export const MetadataContext = createContext<MetadataContextType>({
  metadata: emptyMetadata,
  metadataInfo: emptyMetadataInfo
});
